/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import GridContainerWrapper from 'components/@common/GridContainerWrapper'
import SecurityLogos from 'components/SecurityLogos'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { scroller } from 'react-scroll'
import { GridContainer, Grid } from 'unsemantic'
import useCustomerAccountFeatureFlag from 'hooks/useCustomerAccountFeatureFlag'
import queryString from 'query-string'
import { Message } from '../../components/@common/Message'
import PriceComparison from '../../components/PriceComparison'
import {
  selectPrice,
  updateCampaignData,
  updateFreeGapActivationSelected,
  updateStep,
} from '../../containers/App/actions'
import { showBreakdownIcon } from '../../containers/PaymentBreakdownIcon/actions'
import QuoteSummary from '../../containers/QuoteSummary'
import {
  isButtonDisabled,
  updateQuote,
} from '../../containers/RiskDataCollectionPage/actions'
import {
  useAffiliate,
  useDuration,
  usePrice,
  useRiskData,
  useSystemFeatures,
  useVehicle,
  useScheme,
} from '../../hooks'
import { InitialStateType, PriceState } from '../../initialState'
import CashbackBanner from './components/CashbackBanner'
import DrivingLicenceAB from './components/DrivingLicenceAB'
import './driving-licence.css'
import {
  PriceComparisonWrapper,
  QuotesHeader,
  SecurityLogosWrapper,
} from './DrivingLicence.styles'
import Button from 'components/@common/Button'
import { trackEvent, trackAmplitudeEvent } from 'utils/analytics-helpers'

const DrivingLicence: React.FC = () => {
  const dispatch = useDispatch()

  const [underwriterChanged, setUnderwriterChanged] = useState<boolean>(false)

  const [comparisonSelectedPriceIndex, setComparisonSelectedPriceIndex] =
    useState<number | null>(null)

  const priceComparisonContainer = useRef(null)

  const myLicence = useSelector((store: InitialStateType) => store.myLicence)
  const location = useLocation<{ fraudFailure: boolean }>()
  const address = useSelector((store: InitialStateType) => store.address)
  const isDrivingLicenceFormButtonDisabled = useSelector(
    (store: InitialStateType) => store.formButtons.driverLicence.disabled,
  )
  const quoteUnderwriter = useSelector(
    (store: InitialStateType) => store.quote.Underwriter,
  )

  const { registrationNumber, vehicleType } = useVehicle()
  const { duration, durationType } = useDuration()
  const { affiliate } = useAffiliate()
  const { price } = usePrice()
  const { riskData } = useRiskData()
  const { IsCashbackEnabled } = useSystemFeatures()
  const history = useHistory()
  const { scheme } = useScheme()

  const amplitudeEventData = {
    quote_id: riskData.QuoteId,
    product_type: vehicleType,
    scheme: scheme,
    registration: registrationNumber,
    quote_start_date: riskData.PolicyStartDate.value || 'Immediately', // only populates on manual changes
    quote_duration: duration,
    quote_duration_type: durationType,
    quote_underwriter: price.Underwriter,
    price: price.TotalPrice,
  }

  const { data: featureFlagEnabled, isLoading: featureFlagLoading } =
    useCustomerAccountFeatureFlag('FreeGAPActivationJourney')

  const isGapActivationEnabled =
    price.FreeGAPInsuranceCover.FreeGAPInsuranceAvailable &&
    !featureFlagLoading &&
    featureFlagEnabled &&
    featureFlagEnabled?.data

  const [freeGapSelected, setFreeGapSelected] = useState(
    price.FreeGAPInsuranceCover.FreeGapAdded,
  )

  useEffect(() => {
    const parsedQueryString = queryString.parse(window.location.search)
    const queryStringAffiliateRef = parsedQueryString.ref

    if (
      queryStringAffiliateRef !== undefined &&
      queryStringAffiliateRef !== '' &&
      queryStringAffiliateRef !== null &&
      affiliate.Ref !== null &&
      queryStringAffiliateRef !== affiliate.Ref
    ) {
      history.push(
        history.location.search.replace(
          queryStringAffiliateRef.toString(),
          affiliate.Ref,
        ),
      )
    }
  }, [affiliate, history])

  const fraudFailure = useMemo(() => {
    if (location.state) {
      return location.state.fraudFailure
    }

    return undefined
  }, [location])

  const AddressInfo = useMemo(() => {
    if (address.SelectedAddress) {
      return address.SelectedAddress
    }

    return `${address.AddressLineOne} ${address.AddressLineTwo} ${address.AddressLineThree} ${address.AddressLineFour}`
      .trim()
      .concat(` ${address.Postcode}`)
  }, [address])

  const isContinueButtonDisabled = useMemo(
    () => isDrivingLicenceFormButtonDisabled || price.isUpdating,
    [price.isUpdating, isDrivingLicenceFormButtonDisabled],
  )

  const isPriceLoading = useMemo(
    () => price.IsAddonUpdating,
    [price.IsAddonUpdating],
  )

  const hasQuotes = useMemo(
    () =>
      price.TotalPrice > 0 ||
      (price.Prices && price.Prices.filter((p) => p.TotalPrice > 0).length > 0),
    [price],
  )

  const handlePriceSelected = (priceIndex: number | null) => {
    setTimeout(() => {
      scroller.scrollTo(`PriceBlock_${priceIndex}`, {
        duration: 500,
        delay: 0,
        offset: -20,
        smooth: 'easeInOutQuart',
      })
    }, 70)

    setComparisonSelectedPriceIndex(priceIndex)
  }

  const handleContinueClick = (priceValue: PriceState | null = null) => {
    dispatch(
      isButtonDisabled({
        buttonName: 'driverLicence',
        disabled: true,
      }),
    )

    if (!priceValue) {
      trackEvent('ClickedPricePageButton', {
        Underwriter: price?.Underwriter,
      })
      trackAmplitudeEvent('quote_selected', amplitudeEventData)
      dispatch(
        updateQuote({
          partialValidation: true,
          confirmRiskData: true,
          getPrice: false,
          requestConfusedQuickQuote: true,
          gapActivationIncluded: freeGapSelected,
        }),
      )
      dispatch(updateFreeGapActivationSelected(freeGapSelected))
    } else {
      dispatch(selectPrice(priceValue))

      // update discount if there
      dispatch(updateCampaignData(priceValue))
    }
  }

  useEffect(() => {
    dispatch(updateStep(1))
    dispatch(showBreakdownIcon(null))

    if (
      (quoteUnderwriter &&
        quoteUnderwriter !== 'Uninitialised' &&
        price.Underwriter &&
        quoteUnderwriter !== price.Underwriter) ||
      price.UnderwriterChanged
    ) {
      setUnderwriterChanged(true)
    }
  }, [dispatch, price.Underwriter, price.UnderwriterChanged, quoteUnderwriter])

  useEffect(() => {
    if (underwriterChanged) {
      trackEvent('Price page - Price Change')
    }
  }, [underwriterChanged])

  useEffect(() => {
    setComparisonSelectedPriceIndex(null)
  }, [registrationNumber, duration])

  useEffect(() => {
    trackAmplitudeEvent('quote_pageview', amplitudeEventData)
    trackAmplitudeEvent('quote_displayed', amplitudeEventData)
  }, [])

  useEffect(() => {
    if (!hasQuotes) {
      trackEvent('Price page - No Quote')
      trackAmplitudeEvent('quote_zero_price', amplitudeEventData)
      trackAmplitudeEvent('no_quote_generated', amplitudeEventData)
    }
  }, [hasQuotes])

  useEffect(() => {
    if (!price.isUpdating && price.TotalPrice) {
      trackAmplitudeEvent('quote_generated', amplitudeEventData)
    }
  }, [price.TotalPrice])

  useEffect(() => {
    if (price.Prices && comparisonSelectedPriceIndex === null) {
      const existingQuoteUnderwriterPriceIndex = price.Prices.findIndex(
        (p) => p.Underwriter === price.Underwriter,
      )
      if (existingQuoteUnderwriterPriceIndex >= 0) {
        setComparisonSelectedPriceIndex(existingQuoteUnderwriterPriceIndex)
      }
    }
  }, [price, comparisonSelectedPriceIndex])

  const selectFreeGapSelected = (selected: boolean) => {
    setFreeGapSelected(selected)
  }

  return (
    <>
      <GridContainerWrapper pageBottomPadding overflowX='hidden'>
        {/* @ts-ignore TOOD: Revisit as updateQuote isnt a boolean in TS */}
        <QuoteSummary updateQuote />
        {myLicence.CheckFailed &&
          myLicence.FailReasons.indexOf('LicenceHeld') >= 0 && (
            <GridContainer>
              <Message
                heading='Your licence held duration has been updated'
                type='warn'
              >
                Based on the information from your driving licence, we have
                updated the duration you have held your licence to match the
                details held by the DVLA. By proceeding with this quote you
                acknowledge and agree that this information is correct.
              </Message>
            </GridContainer>
          )}

        {underwriterChanged && (
          <GridContainer>
            <Message heading='The quote has been updated' type='info'>
              Please continue and ensure you meet the criteria outlined on the
              next page.
            </Message>
          </GridContainer>
        )}
        {price.UnderwriterChangedByCue && hasQuotes && (
          <GridContainer>
            <Message heading='The quote has been updated' type='warn'>
              Based on the information you have provided and/or information we
              have found, a new insurer has been selected, and your price has
              been updated. Please ensure you have checked the price and are
              happy to proceed before continuing.
            </Message>
          </GridContainer>
        )}

        {fraudFailure && (
          <GridContainer>
            <Message heading='There has been an issue with your quote'>
              Please ensure all data is valid and try again.
            </Message>
          </GridContainer>
        )}
        {!affiliate.PriceComparison && <DrivingLicenceAB />}
        {!registrationNumber && (
          <GridContainer>
            <Message>
              We are unable to proceed any further without a registration.
              Please enter a valid reg to continue.
            </Message>
          </GridContainer>
        )}
        {!hasQuotes && (
          <>
            <GridContainer>
              <Message heading='We have been unable to offer you a quote at this time'>
                We are regularly reviewing our products so we may be able to
                cover you in the future.
              </Message>
            </GridContainer>
          </>
        )}
        {affiliate.PriceComparison &&
          registrationNumber &&
          hasQuotes &&
          affiliate.IsCashbackEnabled &&
          IsCashbackEnabled && <CashbackBanner />}
      </GridContainerWrapper>
      {affiliate.PriceComparison && registrationNumber && hasQuotes && (
        <PriceComparisonWrapper>
          <>
            {!affiliate.IsCashbackEnabled && (
              <QuotesHeader>Your quotes:</QuotesHeader>
            )}
            <div
              className='price-comparison-container'
              ref={priceComparisonContainer}
            >
              {price.Prices && (
                <>
                  {price.Prices.map((priceData, index) => (
                    <PriceComparison
                      key={`price_${index}`}
                      priceData={priceData}
                      selectedUnderwriter={price.UnderwriterId}
                      onContinue={() => handleContinueClick(priceData)}
                      continueButtonDisabled={isContinueButtonDisabled}
                      onSelect={handlePriceSelected}
                      isSelected={index === comparisonSelectedPriceIndex}
                      index={index}
                      addressInfo={AddressInfo}
                      cheapest={
                        price.Prices.filter((p) => p.TotalPriceBeforeAddons > 0)
                          .length > 1 && index === 0
                      }
                    />
                  ))}
                </>
              )}
            </div>
          </>
        </PriceComparisonWrapper>
      )}
      {!affiliate.PriceComparison && registrationNumber && hasQuotes && (
        <GridContainerWrapper topBorderColour='none'>
          <>
            <Grid desktop='100'>
              <Button
                marginBottom='32px'
                fullWidth
                type='submit'
                id='TeslaSubmitPricePageNextButton'
                onClick={() => handleContinueClick()}
                disabled={isContinueButtonDisabled || isPriceLoading}
                data-email={riskData.EmailAddress}
                className={
                  myLicence.DisabledBySetting
                    ? `uw_${price.Underwriter}`
                    : myLicence.Enabled
                    ? `ab_mylicence_on uw_${price.Underwriter}`
                    : `ab_mylicence_off uw_${price.Underwriter}`
                }
                loading={isContinueButtonDisabled || isPriceLoading}
              >
                {isContinueButtonDisabled ? 'Please wait' : 'Continue'}
              </Button>
              <SecurityLogosWrapper>
                <SecurityLogos />
              </SecurityLogosWrapper>
            </Grid>
          </>
        </GridContainerWrapper>
      )}
    </>
  )
}

export default DrivingLicence
